'use client';

import type { SortingState } from '@tanstack/react-table';
import { useState } from 'react';

type SortOrder = 'asc' | 'desc';

type SortConfig<T> = {
  field: keyof T;
  order: SortOrder;
};

type UseSortingProps<T> = {
  initialSort?: SortConfig<T> | SortConfig<T>[];
};

function useSorting<T extends object>({
  initialSort,
}: UseSortingProps<T> = {}) {
  const [sorting, setSorting] = useState<SortingState>(() => {
    if (initialSort === undefined) {
      return [];
    }

    const sortConfigs = Array.isArray(initialSort) === true
      ? initialSort
      : [initialSort];

    return sortConfigs.map(config => ({
      id: String(config.field),
      desc: config.order === 'desc',
    }));
  });

  const handleSortingChange = (updatedSorting: SortingState) => {
    setSorting(updatedSorting);
  };

  return {
    sorting,
    handleSortingChange,
  };
}

export default useSorting;
